
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLighthouse as ObiLighthouseElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lighthouse.js';
 
 
 

 
 export const ObiLighthouse = createComponent({
   react: React,
   tagName: 'obi-lighthouse',
   elementClass: ObiLighthouseElement,
   events: {
     
   }
  });
 
 